<html>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <!-- <meta http-equiv="Content-Language" content="fa" *ngIf="lang" /> -->
    
  </head>
  <body id="body">

    <div class="container">
      <div id="header" class="row">
        <div class="w-100">
          <app-header></app-header>
        </div>
      </div>
      <div class="row">
        <div class="w-100" style="overflow: hidden">

          <router-outlet></router-outlet>
        </div>

      </div>
      <!-- <div id="footer" class="row"></div> -->
    </div>
  </body>
</html>
